import { accentColors, lighterVariations, secondaryColors, StyledFlex, Tag } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';
export const StyledPathCardContainer = styled(StyledFlex)<{
  isCurrentPath?: boolean;
  isRecommendedPath?: boolean;
  $isSmall?: boolean;
}>`
  position: relative;
  max-width: 31rem;
  min-height: 8.2rem;
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  background-color: #212c42;
  border: 1px solid #3e475a;
  border-radius: 0.5rem;
  gap: 0rem;
  cursor: pointer;

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.lg}) {
    min-width: ${({
  $isSmall
}) => $isSmall ? '26.5rem' : '34.5rem'};
    max-width: ${({
  $isSmall
}) => $isSmall ? '27rem' : '35rem'};
  }

  &:hover {
    background-color: #3e475a;
    border: 1px solid #878fa2;
  }
  ${({
  isCurrentPath,
  isRecommendedPath
}) => (isCurrentPath || isRecommendedPath) && `
    border: 2px solid #A3EA2A;
    &:hover {
      background-color: #3e475a;
      border: 2px solid #A3EA2A;
    }
  `}
`;
export const StyledPathCardContent = styled(StyledFlex)`
  display: flex;
  flex-direction: column;
  position: relative;
  width: calc(100% - 8rem);
  gap: 1rem;
  padding: 1.6rem;
  place-content: center;

  p {
    line-height: 1.8rem;
  }

  > p {
    text-wrap: wrap;
    font-size: 1.6rem;
  }

  > * p {
    text-wrap: wrap;
    font-size: ${({
  theme
}) => theme.fonts.sizes.small};
  }

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.md}) and (max-width: ${({
  theme
}) => theme.sizes.lg}) {
    margin-top: none;
    > p {
      text-wrap: wrap;
    }
  }
`;
export const StyledPathTag = styled.p`
  background-color: #2d3d5f;
  color: #f9f9fb;
  padding: 0rem 1rem;
  border-radius: 1.5rem;
  font-size: ${({
  theme
}) => theme.fonts.sizes.tiny};
`;
export const StyledCurrentPathTag = styled.div`
  background-color: #a3ea2a;
  position: absolute;
  font-size: ${({
  theme
}) => theme.fonts.sizes.tiny};
  text-align: center;
  top: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0.5rem 0.5rem 0 0;
  transform: translate(0%, -100%);
  width: 15rem;
  padding: 0.2rem;
  font-weight: 600;
  color: ${secondaryColors.black};
`;
export const StyledProgressContainer = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.md}) and (max-width: ${({
  theme
}) => theme.sizes.lg}) {
    display: none;
  }
`;
export const StyledPaidTag = styled(Tag)`
  background: ${lighterVariations.blue.darker};
  color: ${accentColors.info.dark};
  line-hegiht: 1.8rem;
  font-size: 1.3rem;
`;
export const StyledPaidTagWrapper = styled.div`
  position: relative;
  &:hover {
    div[role='tooltip'] {
      opacity: 1;
      visibility: visible;
    }
  }
`;
export const StyledTooltipWrapper = styled.div`
  display: flex;
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  div[role='tooltip'] {
    background: ${({
  theme
}) => theme.colors.background.tertiary}
    color: ${({
  theme
}) => theme.colors.text.main};
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    visibility: hidden;
    width: 22.5rem;

    &::before {
      border-color: ${({
  theme
}) => theme.colors.background.tertiary}
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
    }
  }
`;
export const StyledFlexContent = styled(StyledFlex)`
  display: flex;
  gap: 1rem;
  justify-content: Start;
  flex-wrap: wrap;

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.lg}) {
    flex-wrap: no-wrap;
  }
`;